import React from "react";
import DashboardGroupmodule from "./dashboard_group_module";
import services from "../../services";
import { withRouter } from "react-router-dom";
import TablePagination from "../common/TablePagination";
import TableHeader from "../common/table_header";
import DeleteModal from "../common/delete_modal";
import Main from "../../Pages/Demo/main";
import { Button } from "@progress/kendo-react-buttons";
import Lang from "../../lang";
import $ from "jquery";
import TlkTable from "../tlelrik/table/tlkTable";
import SearchFilter from "../filters/SearchFilter";

const columnkeyMap = {
    groupName: Lang.langCheck.langRequest("Group Name"),
    noofUsers: Lang.langCheck.langRequest("No Of Users"),
    obzervations: Lang.langCheck.langRequest("Observation"),
    status: Lang.langCheck.langRequest("Status"),
};

const filters = {
    Tabs: {
        Grupos: [
            {
                key: "Nome do grupo",
                displayKey: "procurar por nome do grupo",
                inputType: "text",
            },
            {
                key: "Estado",
                displayKey: "procurar por estado",
                inputType: "dropdown",
                option: [
                    { key: "Ativo", value: "Ativo" },
                    { key: "Inativo", value: "Inativo" },
                ],
            },
            {
                key: "Observação",
                displayKey: "procurar por observação",
                inputType: "text",
            },
        ],
    },
    checkbox: [],
};

class DashboardGroup extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            data: [],
            grpID: "",
            tlkState: null,
            telkikTable: "",
            totalcount: "0",
            SortBy: "ID",
            IsSortTypeDESC: false,
            Paginate: true,
            Page: 1,
            PageSize: 10,
            Filters: null,
            popUpForm: "",
        };
    }

    /* Esta é a primeira etapa após o construxctor para carregar este componente  */

    componentDidMount() {
        this.createpayload();
    }

    createpayload = () => {
        let data = {
            Filters: this.state.Filters,
            SortBy: this.state.SortBy,
            IsSortTypeDESC: this.state.IsSortTypeDESC,
            IsPagination: this.state.Paginate,
            Page: this.state.Page,
            PageSize: this.state.PageSize,
        };
        this.getGroupList(data);
    };
    /*  Para obter a chave de filtros dos filtros personalizados para recuperar a API com base nisso */

    getFilters = (customfilters) => {
        let Filters = {};
        console.log("custome filter", customfilters);
        if (
            customfilters &&
            customfilters.filters &&
            customfilters.filters["Estado"]
        )
            Filters["Estado"] =
                customfilters.filters["Estado"] === "Ativo"
                    ? "Active"
                    : "InActive";

        if (
            customfilters &&
            customfilters.filters &&
            customfilters.filters["Nome do grupo"]
        )
            Filters["Nome"] = customfilters.filters["Nome do grupo"];

        if (
            customfilters &&
            customfilters.filters &&
            customfilters.filters["Observação"]
        )
            Filters["Observação"] = customfilters.filters["Observação"];

        this.setState({ Filters: Filters, telkikTable: null }, () =>
            this.createpayload()
        );
    };

    handleFilter = (data) => {
        this.setState(
            {
                telkikTable: null,
                filterData: data,
            },
            () => this.createTabel()
        );
    };

    updatelistsort = (sort, key) => {
        this.setState(
            {
                SortBy: key,
                SortType: sort,
            },
            () => this.createpayload()
        );
    };
    updatelistpagenumsize = (PageSize, page_num) => {
        this.setState(
            {
                Page: page_num,
                PageSize: PageSize,
            },
            () => this.createpayload()
        );
    };

    handleGrpID = (id) => {
        //console.log("jhjhjhjh",id)
        this.setState(
            {
                grpID: id,
            },
            () => this.showPopUpForm(this.state.grpID)
        );
    };

    columnlist = Object.keys(columnkeyMap).map(function (key) {
        return { field: columnkeyMap[key], columnMenuType: "checkbox" };
    });

    createTabel = () => {
        let actionbuttons = {
            GroupEdit: true,
            PermissionRedirect: "Permissões de perfil",
            AdministrationDelete: "Group",
        };
        //console.log("DATA",this.state.data);
        // let telkikTable = <Main date={new Date()} deleteFunc={(id)=>this.handleDelete(id)} list={this.state.data} actionbuttons={actionbuttons} columnlist={this.columnlist} ActionPerform={(action,id)=>this.ActionPerform(action,id)}/>
        let telkikTable = (
            <TlkTable
                tlkState={this.state.tlkState}
                tableFilters={(filter) => this.tableFilters(filter)}
                date={new Date()}
                modulename={"group"}
                deleteFunc={(id) => this.handleDelete(id)}
                list={this.state.data}
                actionbuttons={actionbuttons}
                columnlist={this.columnlist}
                ActionPerform={(action, id) => this.ActionPerform(action, id)}
            />
        );
        this.setState({
            telkikTable: telkikTable,
        });
    };

    tableFilters = (filter) => {
        let tlkState = { ...filter };
        let SortBy = "ID";
        let IsSortTypeDESC = false;
        let columnkeyMaprev = {};
        for (var key in columnkeyMap) {
            columnkeyMaprev[columnkeyMap[key]] = key;
        }
        if (filter && filter.sort && filter.sort.length > 0) {
            SortBy = columnkeyMaprev[filter.sort[0].field];
            IsSortTypeDESC = filter.sort[0].dir === "asc" ? false : true;
        }
        this.setState(
            {
                Page: Math.ceil(filter.skip / filter.take) + 1,
                PageSize: filter.take || 100,
                SortBy,
                IsSortTypeDESC,
                tlkState,
            },
            () => {
                this.createpayload();
            }
        );
    };

    /*  Para realizar a ação com base na seleção da tabela  */

    ActionPerform = (action, row) => {
        if (action == "Redirect") {
            console.log("Action", action, row);
            this.props.history.push({
                pathname: `/admin_dashboard_permissions/${row["groupName"]}/${encodeURIComponent(row["detalheURL"])}`,
                // state: { groupName: row['groupName'], groupID: row['id'] }
                state: { topBarMenu: this.props.location.state.topBarMenu },
            });
        } else if (action === "GroupEdit") {
            this.handleGrpID(row.id);
            // $(".popup-overlay, .popup-content").addClass("active");
        }
    };

    handleDelete = async (row) => {
        let id = parseInt(row.id);
        let res = await services.apiCall.requestApi(
            `/Groups/Delete/${id}`,
            {},
            "post"
        );
        if (res) {
            this.createpayload();
        }
    };

    getGroupList = async (data) => {
        let _grp = await services.apiCall.requestApi(
            "/Groups/AllGroups",
            data,
            "post"
        );
        if (_grp) {
            _grp.map((_row, index) =>
                Object.keys(columnkeyMap).map(function (key) {
                    _row[columnkeyMap[key]] = _row[key];
                })
            );
            this.setState(
                {
                    data: _grp,
                    totalcount: window.localStorage.getItem("table_total"),
                },
                () => this.createTabel()
            );
            // $(".popup-overlay, .popup-content").removeClass("active")
        }
    };

    showPopUpForm = (id) => {
        //console.log("this.state.grpid",id)
        let popUpForm = (
            <DashboardGroupmodule
                grpId={id}
                groupList={() => this.createpayload()}
            />
        );
        this.setState({
            popUpForm,
        });
    };

    render() {
        return (
            <div className="inner-container">
                <div className="outer-space">
                    <div className="row">
                        <div className="col-md-8 order-sm-1 order-2">
                            <div className="heading d-md-flex align-items-center">
                                {/* <img src="imgs/icon1_gray.png" alt=""/>  */}
                                <span
                                    className={`sivdp-icon sivdp-users font-23 mr-3 ml-2 text-grey`}
                                ></span>
                                <h3>{Lang.langCheck.langRequest("Group")}</h3>
                                <Button
                                    onClick={() => this.handleGrpID("")}
                                    primary={true}
                                    data-toggle="modal"
                                    data-target="#new-group"
                                    className="btn-ivdp-primary mr-2 btn-sm"
                                >
                                    + Inserir
                                </Button>

                                {/* <Button primary={true} className="btn-ivdp-primary mr-2 btn-sm dropdown-toggle" data-toggle="dropdown">
                  {("Opções").toUpperCase()}
                </Button>
                <div className="dropdown-menu">
                  <span className="cursor-pointer dropdown-item" href="#">Opções</span>
                  <span className="cursor-pointer dropdown-item" href="#">Opções</span>
                  <span className="cursor-pointer dropdown-item" href="#">Opções</span>
                </div> */}
                            </div>
                            <p className="custom-well">Início</p>
                        </div>
                    </div>

                    {/* <div className="white-box  mb40">
                  <div className="row top-serch">
                     <div className="col-md-12 form-inline">
                        <div className="form-group">
                        <button onClick={()=>this.handleGrpID('')} className="btn btn-theme mr-4" data-toggle="modal" data-target="#new-group">ADD NEW GROUP</button>
                    </div>
                     </div>
                    </div>
                  </div>  */}
                    <SearchFilter
                        searchplaceholder="Selecione um critério de pesquisa junto aos filtros avançados"
                        showSearchDisabled={true}
                        data={this.state.data}
                        handleFilter={(data) => this.handleFilter(data)}
                        filters={filters}
                        getFilter={(data) => this.getFilters(data)}
                    />

                    <div className="table-responsive table-section">
                        <h3>
                            {" "}
                            A pesquisa retornou {this.state.totalcount}{" "}
                            resultados{" "}
                        </h3>
                        {this.state.telkikTable}
                    </div>

                    {
                        // this.state.popupShow &&
                        <div className="modal fade" id="new-group">
                            <div className="modal-dialog modal-dialog-centered">
                                {this.state.popUpForm}
                            </div>
                        </div>
                    }
                </div>
            </div>
        );
    }
}

export default withRouter(DashboardGroup);
